let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("O3OZ0"), load("4g2Mj"), load("9wxKg"), load("9ftJe"), load("jjWia")]).then(() => parcelRequire('liyuV'));